import { isValidLocale } from './locale'

export const getLandingLocale = (search: string): string => {
  const params = new URLSearchParams(search)
  const language = params.get('languageCode')?.toLowerCase()
  const country = params.get('countryCode')?.toUpperCase()
  const locale = `${language}_${country}`
  return isValidLocale(locale) ? locale : 'en_IE'
}
